import { PATCH } from "@/core/services/store/request.module";

export default {
  methods: {
    patchSupplier(supplier, data) {
      const _this = this;
      return new Promise((resolve, reject) => {
        if (supplier) {
          _this.$store
            .dispatch(PATCH, { url: "supplier/" + supplier, data })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              resolve(error);
            });
        } else {
          reject("Supplier is required");
        }
      });
    },
    patchSupplierContactPerson(supplier, persons, data) {
      const _this = this;
      return new Promise((resolve, reject) => {
        if (supplier) {
          _this.$store
            .dispatch(PATCH, {
              url: "supplier/" + supplier + "/contact-person/" + persons,
              data,
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              resolve(error);
            });
        } else {
          reject("Supplier is required");
        }
      });
    },
    patchSupplierProperty(supplier, properties, data) {
      const _this = this;
      return new Promise((resolve, reject) => {
        if (supplier) {
          _this.$store
            .dispatch(PATCH, {
              url: "supplier/" + supplier + "/property-address/" + properties,
              data,
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              resolve(error);
            });
        } else {
          reject("Supplier is required");
        }
      });
    },
    patchSupplierBilling(supplier, data) {
      const _this = this;
      return new Promise((resolve, reject) => {
        if (supplier) {
          _this.$store
            .dispatch(PATCH, {
              url: "supplier/" + supplier + "/billing-address",
              data,
            })
            .then(({ data }) => {
              resolve(data);
            })
            .catch((error) => {
              resolve(error);
            });
        } else {
          reject("Supplier is required");
        }
      });
    },
  },
};
